import { MediaUploadManager } from "./mediaUploadManager";
import { mediaApi } from "./mediaApi";
import { archiveStore } from "./archiveStore";
import { compressImage } from "./imageCompression";
import { originalSha256 } from "./originalHasher";
import { putMedia } from "./uploadTransport";

export function mediaOwnerKey(): string {
  try {
    const auth = JSON.parse(localStorage.getItem("authUser") || "null");
    const user = auth?.users;
    const id = String(user?._id || user?.id || "");
    const studio = String(user?.organizationResponse?._id || user?.organizationResponse?.id || "");
    return id && studio ? studio + ":" + id : "";
  } catch { return ""; }
}
// One shared SPA instance. Interrupt it when logging out or switching organization.
export const mediaUploadManager = new MediaUploadManager({
  api: mediaApi, store: archiveStore, ownerKey: mediaOwnerKey,
  compress: compressImage, hash: originalSha256, put: putMedia,
});
